import { useEffect, useState } from 'react';

import { getKPIPointsOnline } from 'services/dashboard.service';

export type CulturePoints = {
  time: number;
  foco: number;
  colaboracao: number;
  inovacao: number;
  resolutividade: number;
  lideranca: number;
  total: number;
  geral: number;
  tasks: number;
  joga_junto: number;
  ranking_galeria: any;
};

export const EMPTY_CULTURE_POINTS: CulturePoints = {
  time: 0,
  foco: 0,
  colaboracao: 0,
  inovacao: 0,
  resolutividade: 0,
  lideranca: 0,
  total: 0,
  geral: 0,
  tasks: 0,
  joga_junto: 0,
  ranking_galeria: undefined,
};

function toCulturePoints(result: any): CulturePoints {
  const points: CulturePoints = {
    ...EMPTY_CULTURE_POINTS,
    time: result.time,
    total: result.total || 0,
    geral: result.geral || 0,
    tasks: result.tasks || 0,
    joga_junto: result.joga_junto || 0,
    ranking_galeria: result.ranking_galeria || undefined,
  };

  result.positions?.forEach((position: any) => {
    (points as any)[position.behavior] = position.total;
  });

  return points;
}

/**
 * Pontos Joga Junto e Realizações do card de perfil (`find/pontos_online`). Lê de novo quando o
 * player, o ciclo ou o `userRevision` mudam: um `refreshUser` concluído (websocket, volta à Home)
 * traz os pontos novos (DCE-25, DCE-27, DCE-54). Só dependências primitivas (DCE-28).
 *
 * Com `waitingRefresh` (volta com `direction: 'back'`), não lê na montagem: a leitura sai uma vez,
 * quando o refresh termina (DCE-57).
 */
export function useCulturePoints(
  userId?: string,
  cycleId?: string,
  userRevision = 0,
  waitingRefresh = false,
): CulturePoints {
  const [points, setPoints] = useState<CulturePoints>(EMPTY_CULTURE_POINTS);

  useEffect(() => {
    if (!userId || !cycleId || waitingRefresh) return;

    // Resposta que chega depois de desmontar (ou de trocar de ciclo) não grava (DCE-56).
    let active = true;

    getKPIPointsOnline(userId, null, cycleId)
      .then(result => {
        if (active) setPoints(toCulturePoints(result));
      })
      .catch(error => console.error('Erro ao carregar os pontos do perfil:', error));

    return () => {
      active = false;
    };
  }, [userId, cycleId, userRevision, waitingRefresh]);

  return points;
}
